import React from 'react'
import axios from 'axios'
import { apiURL } from 'src/consumer/services'

export async function getCustomerDetails() {
  const token = localStorage.getItem('token')
  const countryCode = localStorage.getItem('countryCode')
  const languageCode = sessionStorage.getItem('languageCode')
  try {
    const res = await axios.get(
      `${apiURL}/api/secure/bc/details?languageCode=${languageCode}&countryCode=${countryCode}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}
